import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Griddle, { plugins, RowDefinition, ColumnDefinition } from 'griddle-react';
// import MapGL from 'react-map-gl';
import GoogleMapReact from 'google-map-react';
import MarkerBlip from './MarkerBlip';

const CustomTableComponent = OriginalComponent => class CustomTableComponent extends React.Component {
  static contextTypes = {
    components: PropTypes.object,
  }
  render() {
    return (
      <div style={{ height: 800, width: 'auto' }}>
        <this.context.components.TableBody />
      </div>
    );
  }
};

const CustomRowComponent = connect((state, props) => ({
  rowData: plugins.LocalPlugin.selectors.rowDataSelector(state, props),
}))(({ rowData }) => (
  <MarkerBlip rowData={rowData} />
));

const sortProperties = [
  { id: 'selected', sortAscending: false },
  { id: 'distance', sortAscending: true },
  { id: 'name', sortAscending: true },
];

class HotelMap extends React.Component {
  constructor(props) {
    super(props);
    this.selectHotelMap = this.selectHotelMap.bind(this);
    this.favHotel = this.favHotel.bind(this);
  }
  selectHotelMap(hotelId) {
    console.log('select hotel from list', hotelId, this.props.eventId);
    this.props.selectHotel(this.props.eventId, hotelId);
  }
  favHotel(hotelId, fav) {
    this.props.favoriteHotel(hotelId, fav);
  }

  render() {
    const centerXY = {
      lat: this.props.place.position.coordinates[1],
      lng: this.props.place.position.coordinates[0],
    };
    const TableBody = connect((state, props) => ({
      visibleData: plugins.LocalPlugin.selectors.visibleDataSelector(state),
    }))(({ rowIds, Row, visibleData }) => (
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyC_dfJjkQ_rwR1TLJ1ZKWUZcttrzDypBJ0' }}
        defaultZoom={14}
        center={centerXY}
      >
        <MarkerBlip
          place={this.props.place}
          lat={this.props.place.position.coordinates[1]}
          lng={this.props.place.position.coordinates[0]}
        />
        { visibleData && visibleData.toJSON().map(r =>
          <Row
            key={r.id}
            griddleKey={r.id}
            lat={r.position.coordinates[1]}
            lng={r.position.coordinates[0]}
            {...r}
          />,
        ) }
      </GoogleMapReact>
      ));


    return (
      <Griddle
        data={this.props.hotels}
        place={this.props.place}
        pageProperties={{
          pageSize: 5000,
        }}
        plugins={[plugins.LocalPlugin]}
        sortProperties={sortProperties}
        components={{
          TableContainer: CustomTableComponent,
          TableBody,
          Row: MarkerBlip,
          SettingsToggle: () => <span />,
          Pagination: () => <span />,
        }}
      />
    );
  }
}

HotelMap.propTypes = {
  hotels: PropTypes.arrayOf(PropTypes.object).isRequired,
  eventId: PropTypes.number.isRequired,
  selectHotel: PropTypes.func.isRequired,
  favoriteHotel: PropTypes.func.isRequired,
};

HotelMap.defaultProps = {
  hotels: [],
};
export default HotelMap;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelMap.js